import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import { API_URL } from '..';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import Swal from 'sweetalert2';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiemFtcCIsImEiOiJjbTkxa3dkcnMwMmQxMnJzYzBobW9hOHBiIn0.GWvvqPrWqtMby0HYCYdjMQ';

const InvoiceEditLayer = ({ invoiceData: initialInvoiceData }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [optionsForServices, setOptionsForServices] = useState([]);
  const [companyData, setCompanyData] = useState({
    name: '',
    address: '',
    email: '',
    phone: '',
    vatRegNo: '',
    logo: '',
    accountNumber: '',
    accountTitle: '',
    sortCode: '',
    
  });
  const [customers, setCustomers] = useState([]);
  const [customerType, setCustomerType] = useState('existing');
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [invoiceData, setInvoiceData] = useState({
    id: '',
    orderNumber: '',
    invoiceNumber: '',
    issuedDate: '',
    dueDate: '',
    customerName: '',
    customerAddress: '',
    customerPhone: '',
    email: '',
    postcode: '',
    latitude: '',
    longitude: '',
    type_of_invoice: '',
    job_site_address:''
  });
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [newItem, setNewItem] = useState({
    itemType: 'stock',
    itemName: null,
    qty: '',
    unitPrice: '',
    description: '',
  });
  const [discount, setDiscount] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState({ show: false, type: '', message: '' });
  const [stockList, setStockList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [addressSuggestions, setAddressSuggestions] = useState([]);
  const addressInputRef = useRef(null);
  const quillRef = useRef(null);
  const quillInstance = useRef(null);

  // Initialize Quill editor
  useEffect(() => {
    if (currentStep === 3 && quillRef.current && !quillInstance.current) {
      quillInstance.current = new Quill(quillRef.current, {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ align: '' }, { align: 'center' }, { align: 'right' }],
          ],
        },
        placeholder: 'Enter item description',
      });

      // Set text direction to LTR and language to English
      quillInstance.current.root.setAttribute('dir', 'ltr');
      quillInstance.current.root.setAttribute('lang', 'en');

      // Ensure cursor is visible and editor has focus
      quillInstance.current.on('text-change', () => {
        const content = quillInstance.current.root.innerHTML;
        setNewItem((prev) => ({ ...prev, description: content }));
        quillInstance.current.focus();
      });

      // Focus the editor on initialization
      quillInstance.current.focus();
    }

    // Cleanup on unmount or step change
    return () => {
      if (quillInstance.current) {
        quillInstance.current.off('text-change');
        quillInstance.current = null;
      }
    };
  }, [currentStep]);

  // Update Quill content when description changes
  useEffect(() => {
    if (quillInstance.current && newItem.description) {
      if (quillInstance.current.root.innerHTML !== newItem.description) {
        quillInstance.current.root.innerHTML = newItem.description;
        quillInstance.current.focus();
      }
    }
  }, [newItem.description]);

  const professionalTemplate = `
    <!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Invoice Rw4620</title>
      <style>
        /* Ensure consistent styling for Quill content */
        .ql-align-center { text-align: center; }
        .ql-align-right { text-align: right; }
        ul, ol { margin-left: 20px; padding-left: 0; }
        li { margin-bottom: 5px; }
        td ol, td ul{
            padding-left:10px;
            list-style:auto;
        }
       
      </style>
  </head>
  <body style="font-family: Arial, sans-serif; margin: 0; padding: 40px; font-size: 12px; color: #000;">
      <!-- Page 1 -->
      <div style="width: 100%; height: auto; margin: 0 auto; padding-top: 20px; box-sizing: border-box;">
          <!-- Header -->
          <table style="width: 100%; border-collapse: collapse;">
              <tr>
                  <td style="width: 50%; vertical-align: top;padding-left:0px;">
                      <div style="font-weight: bold; font-size: 14px;">
                      <img src="{{business_logo}}" style="width:140px;"/>
                      </div>
                      <div style="font-weight: bold; font-size: 14px">{{business_header}}</div>
                      <div style="width:150px;font-size:13px">{{business_address}}</div>
                      <div style="font-size:13px;>{{business_email}}</div>
                      <div style="font-size:13px;">VAT NO: {{vat_reg_no}}</div>
                  </td>
                  <td style="width: 50%; text-align: right; vertical-align: top;padding-right:20px">
                      <div style="font-size:13px;">Issue Date: {{issue_date}}</div>
                  </td>
              </tr>
          </table>
          <!-- Bill To -->
          <div style="text-align:center;padding-top:10px">
          <p style="font-weight: 600; font-size: 18px;">{{type}}</p>
          </div>
          <div style="border-top:3px solid #d17f15;margin-top:10px"/>
          <table style="width: 100%; border-collapse: collapse; margin-top: 20px;">
              <tr>
                  <td style="width: 70%; vertical-align: top;padding-left:10px">
                      <div style="font-weight: bold;">For:</div>
                      <div style="font-size:12px">{{customer_name}}</div>
                      <div style="font-size:12px">{{customer_phone}}</div>
                      <div style="font-size:12px">{{customer_address}}</div>
                  </td>
                  <td style="width: 30%;text-align:left">
                  <div style="font-size:12px">Invoice No: {{invoice_number}}</div>
                  {{order_number}}
                  {{job_site_address}}
                  </td>
              </tr>
          </table>
          <!-- Description Table -->
          <table style="width: 100%; border-collapse: collapse; margin-top: 20px;">
              <tr style="background-color: #d17f15;">
                  <th style="text-align: left; padding: 5px; border-top: 2px solid #d17f15;border-bottom: 2px solid #d17f15;color:white;font-weight:bold">Description</th>
                  <th style="text-align: center; padding: 5px; border-top: 2px solid #d17f15;border-bottom: 2px solid #d17f15;color:white;font-weight:bold">Quantity</th>
                  <th style="text-align: center; padding: 5px; border-top: 2px solid #d17f15;border-bottom: 2px solid #d17f15;color:white;font-weight:bold">Unit Price</th>
                  <th style="text-align: right; padding: 5px; border-top: 2px solid #d17f15;border-bottom: 2px solid #d17f15;color:white;font-weight:bold">Cost</th>
              </tr>
              {{service_items}}
          </table>
          <!-- Payment Instructions -->
          <table style="width: 100%; border-collapse: collapse; margin-top: 20px;padding:10px">
              <tr>
                  <td style="width: 50%; vertical-align: top; background: #f2f2f2; border:3px solid #d17f15; text-align:center; padding: 10px;">
                      <div style="font-weight: bold;">Payment Instructions</div>
                      <div>{{accountTitle}}</div>
                      <div>Sort code: {{sortCode}}</div>
                      <div>Account no: {{accountNumber}}</div>
                  </td>
                  <td style="width: 50%; vertical-align: top; text-align: right;">
                      <div style="padding:5px;background:#f3f3f3">Total Net Amount: £{{subtotal}}</div>
                      {{discount}}
                      {{tax}}
                      <div style="border:1px solid #d17f15;"></div>
                      <div style="font-weight: bold;padding:5px">Invoice Total : £{{total}}</div>
                      <div style="border:1px solid #d17f15;"></div>
                  </td>
              </tr>
          </table>
          <!-- Terms -->
         
      </div>
      <!-- Page 2 -->
      <div style="width: 100%; height: 842px; margin: 0px auto; padding: 10px; box-sizing: border-box; page-break-before: always;">
          <!-- Terms and Conditions -->
          <div style="margin-top: 20px;text-align:center">
              <div style="font-weight: bold;">Terms and Conditions:</div>
              <div style="margin-top: 10px;font-size:12px">
                  <div><strong>Payment Due Date:</strong> Full payment is due within 30 days from the invoice date.</div>
                  <div><strong>Late Payments:</strong> A late fee of 5% of the total invoice amount will be applied to any payment not received by the due date. Interest on overdue balances will accrue at 5% per week until payment is received in full.</div>
                  <div><strong>Methods of Payment:</strong> Payment can be made via bank transfer. Please ensure the invoice number is included in all payments for proper processing.</div>
                  <div><strong>Disputes:</strong> Any disputes regarding the invoice must be reported in writing within 7 days of the invoice date. Disputing any portion of the invoice does not suspend the obligation to pay the undisputed amount by the due date.</div>
                  <div ><strong>Suspension of Service:</strong> Non-payment may result in suspension of service or further legal action, at the discretion of R-Wire Limited.</div>
              </div>
              <div style="margin-top: 20px;">
                  <div style="font-weight: bold;">Disclaimer:</div>
                  <div style="font-size:12px">If payment of invoices is not received, we reserve the right to recover any cost, commissions or fees incurred for the collection of payments including those which may be incurred by using a debt collection agency. There will be a 5% late payment fee applied every 7 days after the due date of the invoice.</div>
              </div>
          </div>
          <!-- Signature -->
          <div style="margin-top: 40px;text-align:center">
              <div  style="font-size:12px"><strong>{{business_footer}}</strong></div>
              <div  style="font-size:12px">{{issue_date_footer}}</div>
              <div  style="font-size:12px">Tel: {{business_phone}}</div>
          </div>
          <div style="display: flex; column-gap: 10px; justify-content: center; border-top: 1px solid #c0c0c0; padding-top: 22px; margin-top: 20px;">
              <div style="width:100%">
                  <img  src="https://api.test.frontforcecrm.com/logo/icos.png">
              </div>
            
          </div>
      </div>
  </body>
  </html>
  `;

  useEffect(() => {
    fetchCompanies();
    fetchCustomers();
    fetchStock();
    fetchServices();
    initializeInvoiceData();
  }, []);

  const fetchServices = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      window.location.href = '/sign-in';
    } else {
      try {
        const response = await fetch(`${API_URL}/api/service`, {
          method: 'GET',
          headers: { Accept: '*/*', 'Content-Type': 'application/json' },
        });
        const data = await response.json();
        const formatted = data.map((e) => ({ label: e.title, value: e.id }));
        setOptionsForServices(formatted);
      } catch (error) {
        setAlert({ show: true, type: 'danger', message: 'Failed to fetch services items' });
      }
    }
  };

  useEffect(() => {
    if (customerType === 'new') {
      const fetchSuggestions = async (query) => {
        if (!query) {
          setAddressSuggestions([]);
          return;
        }
        try {
          const response = await fetch(
            `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
              query
            )}.json?access_token=${MAPBOX_ACCESS_TOKEN}&country=GB`
          );
          const data = await response.json();
          if (data.features) {
            setAddressSuggestions(
              data.features.map((feature) => ({
                label: feature.place_name,
                value: feature.place_name,
                coordinates: feature.geometry.coordinates,
              }))
            );
          }
        } catch (error) {
          console.error('Error fetching address suggestions:', error);
        }
      };

      const handleAddressInput = (e) => {
        const value = e.target.value;
        setInvoiceData((prev) => ({ ...prev, customerAddress: value, latitude: '', longitude: '' }));
        fetchSuggestions(value);
      };

      const input = addressInputRef.current;
      if (input) {
        input.addEventListener('input', handleAddressInput);
        return () => input.removeEventListener('input', handleAddressInput);
      }
    }
  }, [customerType]);

  const initializeInvoiceData = () => {
    setInvoiceData({
      id: initialInvoiceData.id,
      orderNumber: initialInvoiceData.order_number,
      invoiceNumber: initialInvoiceData.invoice_number,
      issuedDate: initialInvoiceData.issue_date,
      dueDate: initialInvoiceData.due_date,
      customerName: initialInvoiceData.customer_name,
      customerAddress: initialInvoiceData.address,
      customerPhone: initialInvoiceData.phone,
      type_of_invoice: initialInvoiceData.type_of_invoice,
      email: initialInvoiceData.email || '',
      postcode: initialInvoiceData.postcode || '',
      job_site_address: initialInvoiceData.job_site_address || '',
      latitude: '',
      longitude: '',
    });

    const company = initialInvoiceData.company;
    const companyOption = {
      value: company.id,
      label: company.name,
      name: company.name,
      address: company.address,
      email: company.email,
      phone: company.phone,
      vat: company.vat,
      logo: company.logo ? `${API_URL}${company.logo}` : '',
      accountNumber: company.accountNumber || '',
      accountTitle: company.accountTitle || '',
      sortCode: company.sortCode || '',
    };
    setSelectedCompany(companyOption);
    setCompanyData({
      name: company.name,
      address: company.address,
      email: company.email,
      phone: company.phone,
      vatRegNo: company.vat,
      logo: company.logo ? `${API_URL}${company.logo}` : '',
      accountNumber: company.accountNumber || '',
      accountTitle: company.accountTitle || '',
      sortCode: company.sortCode || '',
    });

    const items = initialInvoiceData.items.map((item, index) => {
      const isStockItem = stockList.some((stock) => stock.label === item.item_name);
      const itemName = { label: item.item_name, value: item.item_name };
      return {
        id: item.id || index + 1,
        itemName,
        qty: item.quantity,
        unitPrice: item.unit_price,
        price: item.price.toFixed(2),
        itemType: isStockItem ? 'stock' : 'service',
        description: item.description || '',
      };
    });
    setInvoiceItems(items);

    setDiscount(Number(initialInvoiceData.discount));
    setTaxAmount(Number(initialInvoiceData.tax));
  };

  const fetchCompanies = async () => {
    try {
      const response = await fetch(`${API_URL}/api/company`, {
        method: 'GET',
        headers: { Accept: '*/*', 'Content-Type': 'application/json' },
      });
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      if (response.status === 200) {
        if (!Array.isArray(data.companies)) {
          throw new Error('Invalid data format: companies is not an array');
        }
        setCompanies(
          data.companies.map((company) => ({
            value: company.id,
            label: company.name,
            ...company,
          }))
        );
      } else {
        throw new Error(data.message || 'Failed to fetch companies');
      }
    } catch (error) {
      setAlert({ show: true, type: 'danger', message: 'Failed to fetch companies: ' + error.message });
      setCompanies([]);
    }
  };

  const fetchCustomers = async () => {
    try {
      const response = await fetch(`${API_URL}/api/customer/fetch`, {
        method: 'GET',
        headers: { Accept: '*/*', 'Content-Type': 'application/json' },
      });
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      if (response.status === 201) {
        if (!Array.isArray(data.customer)) {
          throw new Error('Invalid data format: customers is not an array');
        }
        const customerList = data.customer.map((customer) => ({
          value: customer.id,
          label: customer.name + ' ' + customer.phone,
          ...customer,
        }));
        setCustomers(customerList);
        const matchedCustomer = customerList.find(
          (c) => c.name === initialInvoiceData.customer_name && c.phone === initialInvoiceData.phone
        );
        if (matchedCustomer) {
          setCustomerType('existing');
          setSelectedCustomer({
            value: matchedCustomer.id,
            label: matchedCustomer.name + ' ' + matchedCustomer.phone,
            name: matchedCustomer.name,
            address: matchedCustomer.address,
            phone: matchedCustomer.phone,
            email: matchedCustomer.email,
            postcode: matchedCustomer.postcode,
          });
          setInvoiceData((prev) => ({
            ...prev,
            email: matchedCustomer.email || '',
            postcode: matchedCustomer.postcode || '',
            customerName: matchedCustomer.name,
            customerAddress: matchedCustomer.address,
            customerPhone: matchedCustomer.phone,
          }));
        } else {
          setCustomerType('new');
        }
      } else {
        throw new Error(data.message || 'Failed to fetch customers');
      }
    } catch (error) {
      setAlert({ show: true, type: 'danger', message: 'Failed to fetch customers: ' + error.message });
      setCustomers([]);
    }
  };

  const fetchStock = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      window.location.href = '/sign-in';
    } else {
      try {
        const response = await fetch(`${API_URL}/api/invoice/stock/fetch`, {
          method: 'GET',
          headers: { Accept: '*/*', 'Content-Type': 'application/json' },
        });
        if (!response.ok) throw new Error('Failed to fetch stock');
        const data = await response.json();
        const formatted = data.stock.map((e) => ({ label: e.title, value: e.id }));
        setStockList(formatted);
      } catch (error) {
        setAlert({ show: true, type: 'danger', message: 'Failed to fetch stock items' });
      }
    }
  };

  const onChangeStock = async (value) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      window.location.href = '/sign-in';
    } else {
      try {
        const response = await fetch(`${API_URL}/api/invoice/stock/fetch-single/${value.value}`, {
          method: 'GET',
          headers: { Accept: '*/*', 'Content-Type': 'application/json' },
        });
        if (!response.ok) throw new Error('Failed to fetch stock details');
        const data = await response.json();
        setNewItem({
          ...newItem,
          itemName: value,
          unitPrice: data.stock.sellPrice,
          description: data.stock.description || '',
        });
      } catch (error) {
        setAlert({ show: true, type: 'danger', message: 'Failed to fetch stock details' });
      }
    }
  };

  const onChangeService = async (value) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      window.location.href = '/sign-in';
    } else {
      try {
        const response = await fetch(`${API_URL}/api/service/${value.value}`, {
          method: 'GET',
          headers: { Accept: '*/*', 'Content-Type': 'application/json' },
        });
        if (!response.ok) throw new Error('Failed to fetch service details');
        const data = await response.json();
        setNewItem({
          ...newItem,
          itemName: value,
          qty: '1',
          description: data.description || '',
          unitPrice: data.price,
        });
      } catch (error) {
        setAlert({ show: true, type: 'danger', message: 'Failed to fetch service details' });
      }
    }
  };

  const handleCompanyChange = (selectedOption) => {
    setSelectedCompany(selectedOption);
    if (selectedOption) {
      setCompanyData({
        name: selectedOption.name || '',
        address: selectedOption.address || '',
        email: selectedOption.email || '',
        phone: selectedOption.phone || '',
        vatRegNo: selectedOption.vat || selectedOption.vatNo || '',
        logo: selectedOption.logo ? `${API_URL}${selectedOption.logo}` : '',
        accountNumber: selectedOption.accountNumber || '',
        accountTitle: selectedOption.accountTitle || '',
        sortCode: selectedOption.sortCode || '',
      });
    } else {
      setCompanyData({
        name: '',
        address: '',
        email: '',
        phone: '',
        vatRegNo: '',
        logo: '',
        accountNumber: '',
        accountTitle: '',
        sortCode: '',
      });
    }
    setErrors({ ...errors, company: '' });
  };

  const handleCustomerChange = (selectedOption) => {
    setSelectedCustomer(selectedOption);
    if (selectedOption) {
      setInvoiceData({
        ...invoiceData,
        customerName: selectedOption.name || '',
        customerAddress: selectedOption.address || '',
        customerPhone: selectedOption.phone || '',
        email: selectedOption.email || '',
        postcode: selectedOption.postcode || '',
        latitude: '',
        longitude: '',
      });
    } else {
      setInvoiceData({
        ...invoiceData,
        customerName: '',
        customerAddress: '',
        customerPhone: '',
        email: '',
        postcode: '',
        latitude: '',
        longitude: '',
      });
    }
    setErrors({ ...errors, customer: '' });
  };

  const handleInvoiceChange = (field, value) => {
    setInvoiceData({ ...invoiceData, [field]: value });
    setErrors({ ...errors, [field]: '' });
  };

  const handleAddressSelect = (selected) => {
    if (selected) {
      setInvoiceData({
        ...invoiceData,
        customerAddress: selected.value,
        latitude: selected.coordinates[1],
        longitude: selected.coordinates[0],
      });
      setAddressSuggestions([]);
      setErrors({ ...errors, customerAddress: null });
    }
  };

  const fetchCoordinates = async (address) => {
    if (!address) return { latitude: '', longitude: '' };
    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
          address
        )}.json?access_token=${MAPBOX_ACCESS_TOKEN}&country=GB&limit=1`
      );
      const data = await response.json();
      if (data.features?.length > 0) {
        const [longitude, latitude] = data.features[0].geometry.coordinates;
        return { latitude, longitude };
      }
      return { latitude: '', longitude: '' };
    } catch (error) {
      console.error('Error fetching coordinates:', error);
      return { latitude: '', longitude: '' };
    }
  };

  const validateStep = () => {
    const newErrors = {};
    if (currentStep === 1) {
      if (!selectedCompany) newErrors.company = 'Please select a company';
    } else if (currentStep === 2) {
      if (!invoiceData.invoiceNumber) newErrors.invoiceNumber = 'Invoice number is required';
      if (!invoiceData.issuedDate) newErrors.issuedDate = 'Issued date is required';
      if (!invoiceData.dueDate) newErrors.dueDate = 'Due date is required';
      if (customerType === 'existing') {
        if (!selectedCustomer) newErrors.customer = 'Please select a customer';
      } else {
        if (!invoiceData.customerName) newErrors.customerName = 'Customer name is required';
        if (!invoiceData.customerAddress) newErrors.customerAddress = 'Customer address is required';
        if (!invoiceData.customerPhone) newErrors.customerPhone = 'Customer phone is required';
        if (!invoiceData.email || !/\S+@\S+\.\S+/.test(invoiceData.email))
          newErrors.email = 'Valid email is required';
        if (!invoiceData.postcode) newErrors.postcode = 'Postcode is required';
      }
    } else if (currentStep === 3) {
      if (invoiceItems.length === 0) newErrors.items = 'At least one item is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validateStep()) {
      setCurrentStep(currentStep + 1);
      setErrors({});
    }
  };

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
    setErrors({});
  };

  const handleStepClick = (step) => {
    if (step <= currentStep) {
      setCurrentStep(step);
      setErrors({});
    }
  };

  const handleItemChange = (field, value) => {
    setNewItem({ ...newItem, [field]: value });
    setErrors({ ...errors, [field]: '' });
  };

  const addItem = () => {
    const errors = {};
    if (!newItem.itemName) errors.itemName = 'Item is required';
    if (!newItem.unitPrice) errors.unitPrice = 'Unit price is required';
    if (newItem.itemType === 'stock' && !newItem.qty) errors.qty = 'Quantity is required';
    if (!newItem.description.trim() || newItem.description === '<p><br></p>') errors.description = 'Description is required';

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    const qty = newItem.itemType === 'service' ? 1 : parseFloat(newItem.qty);
    setInvoiceItems([
      ...invoiceItems,
      {
        id: invoiceItems.length + 1,
        itemName: newItem.itemName,
        qty,
        unitPrice: parseFloat(newItem.unitPrice),
        price: (qty * parseFloat(newItem.unitPrice)).toFixed(2),
        itemType: newItem.itemType,
        description: newItem.description.trim(),
      },
    ]);
    setNewItem({ itemType: 'stock', itemName: null, qty: '', unitPrice: '', description: '' });
    if (quillInstance.current) {
      quillInstance.current.root.innerHTML = '';
      quillInstance.current.focus();
    }
    setErrors({});
  };

  const removeItem = (id) => {
    setInvoiceItems(invoiceItems.filter((item) => item.id !== id));
  };

  const calculateSubtotal = () => invoiceItems.reduce((acc, item) => acc + parseFloat(item.price), 0);

  const calculateDiscount = () => (calculateSubtotal() * discount) / 100;

  const calculateTax = () => ((calculateSubtotal() - calculateDiscount()) * taxAmount) / 100;

  const calculateTotal = () => {
    const subtotal = calculateSubtotal();
    const discountAmount = calculateDiscount();
    const tax = calculateTax();
    return subtotal - discountAmount + tax;
  };

  const createCustomer = async () => {
    let latitude = invoiceData.latitude;
    let longitude = invoiceData.longitude;
    if (!latitude || !longitude) {
      const coords = await fetchCoordinates(invoiceData.customerAddress);
      latitude = coords.latitude;
      longitude = coords.longitude;
    }
    const obj = {
      name: invoiceData.customerName,
      address: invoiceData.customerAddress,
      phone: invoiceData.customerPhone,
      email: invoiceData.email,
      postcode: invoiceData.postcode,
      map_location: latitude && longitude ? `${latitude},${longitude}` : '',
    };
    try {
      const response = await fetch(`${API_URL}/api/customer/signup-without-password`, {
        method: 'POST',
        body: JSON.stringify(obj),
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      if (response.status === 201) {
        return data.customer.id;
      } else {
        throw new Error(data.message || 'Failed to create customer');
      }
    } catch (error) {
      throw new Error('Failed to create customer: ' + error.message);
    }
  };

  const handleInvoiceSubmit = async () => {
    if (validateStep()) {
      setIsSubmitting(true);
      try {
        let customerId;
        if (customerType === 'existing') {
          customerId = selectedCustomer.value;
        } else {
          customerId = await createCustomer();
        }

        const obj = {
          id: invoiceData.id,
          invoice_number: invoiceData.invoiceNumber,
          customer_name: invoiceData.customerName,
          phone: invoiceData.customerPhone,
          address: invoiceData.customerAddress,
          email: invoiceData.email,
          issue_date: invoiceData.issuedDate,
          due_date: invoiceData.dueDate,
          amount: calculateTotal(),
          discount: discount,
          tax: taxAmount,
          job_id:  initialInvoiceData.job_id || null,
          order_number: invoiceData.orderNumber ? invoiceData.orderNumber : null,
          job_site_address: invoiceData.job_site_address || null,
          items: invoiceItems.map((item) => ({
            id: item.id,
            item_name: item.itemName.label || item.itemName.value,
            quantity: item.qty,
            unit_price: item.unitPrice,
            price: item.price,
            description: item.description,
          })),
          company_id: selectedCompany.value,
          customer_id: customerId,
          type_of_invoice: invoiceData.type_of_invoice,
        };

        const response = await fetch(`${API_URL}/api/invoice/update/${invoiceData.id}`, {
          method: 'PUT',
          body: JSON.stringify(obj),
          headers: {
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();
        if (response.status === 200) {
          Swal.fire({
            title: 'Invoice',
            text: 'Your invoice is successfully updated.',
            icon: 'success',
          });
          setAlert({ show: true, type: 'primary', message: 'Invoice updated successfully' });
        } else {
          setAlert({
            show: true,
            type: 'danger',
            message: data.message || 'Failed to update invoice',
          });
        }
      } catch (error) {
        setAlert({
          show: true,
          type: 'danger',
          message: error.message || 'Network error occurred',
        });
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const renderTemplate = () => {
    function checkOddEven(index) {
      return index % 2 === 0 ? 'Even' : 'Odd';
    }

    function convertDateFormat(dateString) {
      const [year, month, day] = dateString.split('-');
      const date = `${day}-${month}-${year}`;
      return date;
    }

    const serviceItems = invoiceItems
      .map((item, index) => {
        const descriptionHtml = item.description || 'N/A';
        if (checkOddEven(index) === 'Even') {
          return `
            <tr>
              <td style="padding: 5px; vertical-align: top; border: 1px dotted #c0c0c0; border-left: 1px dotted #c0c0c0; font-size:14px">
                ${item.itemName?.label || item.itemName?.value || 'N/A'}<br>
                <div>${descriptionHtml}</div>
              </td>
              <td style="text-align: center; padding: 5px; border: 1px dotted #c0c0c0; font-size:14px">${item.qty}</td>
              <td style="text-align: center; padding: 5px; border: 1px dotted #c0c0c0; font-size:14px">£${item.unitPrice.toFixed(2)}</td>
              <td style="text-align: right; padding: 5px; border: 1px dotted #c0c0c0; font-size:14px">£${item.price}</td>
            </tr>
          `;
        } else {
          return `
            <tr style="background:#f3f3f3">
              <td style="padding: 5px; vertical-align: top; border: 1px dotted #c0c0c0; border-left: 1px dotted #c0c0c0; font-size:14px">
                ${item.itemName?.label || item.itemName?.value || 'N/A'}<br>
                <div>${descriptionHtml}</div>
              </td>
              <td style="text-align: center; padding: 5px; border: 1px dotted #c0c0c0; font-size:14px">${item.qty}</td>
              <td style="text-align: center; padding: 5px; border: 1px dotted #c0c0c0; font-size:14px">£${item.unitPrice.toFixed(2)}</td>
              <td style="text-align: right; padding: 5px; border: 1px dotted #c0c0c0; font-size:14px">£${item.price}</td>
            </tr>
          `;
        }
      })
      .join('');

    return professionalTemplate
      .replace('{{business_logo}}', companyData.logo || './assets/images/logo.png')
      .replace('{{business_header}}', companyData.name || 'Your Company')
      .replace('{{business_address}}', companyData.address || 'Your Address')
      .replace('{{business_phone}}', companyData.phone || 'Your Phone')
      .replace('{{business_email}}', companyData.email || 'Your Email')
      .replace('{{vat_reg_no}}', companyData.vatRegNo || 'Your VAT Reg No')
      .replace('{{invoice_number}}', invoiceData.invoiceNumber || 'N/A')
      .replace('{{order_number}}', invoiceData.orderNumber ? `<div>Order No: ${invoiceData.orderNumber}</div>` : '')
      .replace('{{job_site_address}}', invoiceData.job_site_address ? `<div style="font-size:12px">Site Address: ${invoiceData.job_site_address}</div>` : '')
      .replace('{{issue_date}}', convertDateFormat(invoiceData.issuedDate) || 'N/A')
      .replace('{{issue_date_footer}}', convertDateFormat(invoiceData.issuedDate) || 'N/A')
      .replace('{{due_date_of_invocie}}', convertDateFormat(invoiceData.dueDate) || 'N/A')
      .replace('{{type}}', 'Invoice')
      .replace('{{customer_name}}', invoiceData.customerName || 'N/A')
      .replace('{{customer_address}}', invoiceData.customerAddress || 'N/A')
      .replace('{{customer_phone}}', invoiceData.customerPhone || 'N/A')
      .replace('{{authorized_by}}', 'N/A')
      .replace('{{tow_from}}', 'N/A')
      .replace('{{tow_to}}', 'N/A')
      .replace('{{accountNumber}}', companyData.accountNumber || 'N/A')
      .replace('{{sortCode}}', companyData.sortCode || 'N/A')
      .replace('{{accountTitle}}', companyData.accountTitle || 'N/A')
      .replace('{{vehicle_color}}', 'N/A')
      .replace('{{vehicle_vin}}', 'N/A')
      .replace('{{vehicle_plate}}', 'N/A')
      .replace('{{service_items}}', serviceItems)
      .replace('{{subtotal}}', calculateSubtotal().toFixed(2))
      .replace('{{discount}}', discount === 0 ? '<div style="padding:15px;"></div>' : `<div style="padding:5px">Discount: £${calculateDiscount().toFixed(2)}</div>`)
      .replace('{{tax}}', taxAmount !== 0 ? `<div style="padding:5px;">Total VAT Amount: £${calculateTax().toFixed(2)}</div>` : '<div style="padding:15px;"></div>')
      .replace('{{total}}', calculateTotal().toFixed(2))
      .replace('{{business_footer}}', companyData.name || 'Your Company')
      .replace('{{business_phones}}', companyData.phone || 'Your Phone');
  };

  const closeAlert = () => {
    setAlert({ show: false, type: '', message: '' });
  };

  const steps = ['Company Selection', 'Customer Information', 'Edit Items', 'Preview'];

  return (
    <div className="container py-5">
      <style>
      {`
        .ql-container {
          font-family: Arial, sans-serif;
          font-size: 14px;
          min-height: 150px;
          border: 1px solid #ced4da;
          border-radius: 4px;
          direction: ltr;
        }
        .ql-container.is-invalid {
          border-color: #dc3545;
        }
        .ql-editor {
          min-height: 120px;
          padding: 10px;
        }
        .ql-toolbar {
          border-bottom: 1px solid #ced4da;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
        }
        .ql-editor:focus {
          outline: none;
          box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
        }
        td ul, td ol , td p{
          margin-bottom:0px;
        }
      `}
      </style>
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-white border-bottom">
              <h6 className="h6 mb-0 text-center">Edit Invoice</h6>
            </div>
            <div className="card-body">
              <div className="d-flex justify-content-center mb-5">
                {steps.map((step, index) => (
                  <div key={index} className="text-center mx-2">
                    <button
                      className={`btn btn-sm btn-${
                        currentStep > index + 1 ? 'success' : currentStep === index + 1 ? 'primary' : 'secondary'
                      } rounded-circle`}
                      style={{ width: '40px', height: '40px', lineHeight: '1' }}
                      onClick={() => handleStepClick(index + 1)}
                      disabled={currentStep < index + 1}
                    >
                      {index + 1}
                    </button>
                    <div className="mt-2 small">{step}</div>
                  </div>
                ))}
              </div>

              {alert.show && (
                <div className={`alert alert-${alert.type} alert-dismissible fade show mb-4`} role="alert">
                  {alert.message}
                  <button type="button" className="btn-close" onClick={closeAlert} aria-label="Close"></button>
                </div>
              )}

              {currentStep === 1 && (
                <div className="p-3 rounded">
                  <h2 className="h6 mb-4">Company Selection</h2>
                  <div className="row g-3">
                    <div className="col-12">
                      <label htmlFor="companySelect" className="form-label fw-bold">
                        Select Company
                      </label>
                      <Select
                        inputId="companySelect"
                        options={companies}
                        value={selectedCompany}
                        onChange={handleCompanyChange}
                        className={`react-select ${errors.company ? 'is-invalid' : ''}`}
                        classNamePrefix="select"
                        placeholder="Select a company"
                      />
                      <div className="form-text">Select the company for this invoice.</div>
                      {errors.company && <div className="invalid-feedback d-block">{errors.company}</div>}
                    </div>
                    {selectedCompany && (
                      <>
                        <div className="col-md-6">
                          <label className="form-label fw-bold">Company Name</label>
                          <input type="text" value={companyData.name} className="form-control form-control-lg" readOnly />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label fw-bold">Address</label>
                          <input
                            type="text"
                            value={companyData.address}
                            className="form-control form-control-lg"
                            readOnly
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label fw-bold">Email</label>
                          <input
                            type="email"
                            value={companyData.email}
                            className="form-control form-control-lg"
                            readOnly
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label fw-bold">Phone</label>
                          <input type="text" value={companyData.phone} className="form-control form-control-lg" readOnly />
                        </div>
                        <div className="col-12">
                          <label className="form-label fw-bold">VAT Registration No</label>
                          <input
                            type="text"
                            value={companyData.vatRegNo}
                            className="form-control form-control-lg"
                            readOnly
                          />
                        </div>
                        <div className="col-12">
                          <label className="form-label fw-bold">Company Logo</label>
                          <div className="mt-3">
                            <img
                              src={companyData.logo || './assets/images/logo.png'}
                              alt="Company Logo"
                              className="img-thumbnail img-fluid"
                              style={{ maxWidth: '150px' }}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}

              {currentStep === 2 && (
                <div className="p-3 rounded">
                  <h2 className="h6 mb-4">Customer Information</h2>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label htmlFor="invoiceNumber" className="form-label fw-bold">
                        Invoice Number
                      </label>
                      <input
                        type="text"
                        id="invoiceNumber"
                        disabled
                        value={invoiceData.invoiceNumber}
                        onChange={(e) => handleInvoiceChange('invoiceNumber', e.target.value)}
                        className={`form-control form-control-lg ${errors.invoiceNumber ? 'is-invalid' : ''}`}
                      />
                      <div className="form-text">e.g., INV-001</div>
                      {errors.invoiceNumber && <div className="invalid-feedback">{errors.invoiceNumber}</div>}
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="issuedDate" className="form-label fw-bold">
                        Issued Date
                      </label>
                      <input
                        type="date"
                        id="issuedDate"
                        value={invoiceData.issuedDate}
                        onChange={(e) => handleInvoiceChange('issuedDate', e.target.value)}
                        className={`form-control form-control-lg ${errors.issuedDate ? 'is-invalid' : ''}`}
                      />
                      <div className="form-text">Select the issue date.</div>
                      {errors.issuedDate && <div className="invalid-feedback">{errors.issuedDate}</div>}
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="dueDate" className="form-label fw-bold">
                        Due Date
                      </label>
                      <input
                        type="date"
                        id="dueDate"
                        value={invoiceData.dueDate}
                        onChange={(e) => handleInvoiceChange('dueDate', e.target.value)}
                        className={`form-control form-control-lg ${errors.dueDate ? 'is-invalid' : ''}`}
                      />
                      <div className="form-text">Select the due date.</div>
                      {errors.dueDate && <div className="invalid-feedback">{errors.dueDate}</div>}
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="orderNumber" className="form-label fw-bold">
                        Order Number
                      </label>
                      <input
                        type="text"
                        id="orderNumber"
                        value={invoiceData.orderNumber}
                        onChange={(e) => handleInvoiceChange('orderNumber', e.target.value)}
                        className={`form-control form-control-lg ${errors.orderNumber ? 'is-invalid' : ''}`}
                      />
                      <div className="form-text">e.g., 12233</div>
                      {errors.orderNumber && <div className="invalid-feedback">{errors.orderNumber}</div>}
                    </div>
                    <div className="col-12 mb-3">
                      <label className="form-label fw-bold">Customer Type</label>
                      <div className="d-flex">
                        <div className="form-check me-3">
                          <input
                            type="radio"
                            id="existingCustomer"
                            name="customerType"
                            value="existing"
                            checked={customerType === 'existing'}
                            onChange={() => {
                              setCustomerType('existing');
                              setInvoiceData({
                                ...invoiceData,
                                customerName: '',
                                customerAddress: '',
                                customerPhone: '',
                                email: '',
                                postcode: '',
                                latitude: '',
                                longitude: '',
                              });
                              setSelectedCustomer(null);
                              setErrors({});
                            }}
                            className="form-check-input"
                          />
                          <label htmlFor="existingCustomer" className="form-check-label">
                            Existing Customer
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="radio"
                            id="newCustomer"
                            name="customerType"
                            value="new"
                            checked={customerType === 'new'}
                            onChange={() => {
                              setCustomerType('new');
                              setSelectedCustomer(null);
                              setInvoiceData({
                                ...invoiceData,
                                customerName: '',
                                customerAddress: '',
                                customerPhone: '',
                                email: '',
                                postcode: '',
                                latitude: '',
                                longitude: '',
                              });
                              setErrors({});
                            }}
                            className="form-check-input"
                          />
                          <label htmlFor="newCustomer" className="form-check-label">
                            New Customer
                          </label>
                        </div>
                      </div>
                    </div>
                    {customerType === 'existing' && (
                      <div className="col-12">
                        <label htmlFor="customerSelect" className="form-label fw-bold">
                          Select Customer
                        </label>
                        <Select
                          inputId="customerSelect"
                          options={customers}
                          value={selectedCustomer}
                          onChange={handleCustomerChange}
                          className={`react-select ${errors.customer ? 'is-invalid' : ''}`}
                          classNamePrefix="select"
                          placeholder="Select a customer"
                        />
                        <div className="form-text">Select the customer for this invoice.</div>
                        {errors.customer && <div className="invalid-feedback d-block">{errors.customer}</div>}
                      </div>
                    )}
                    {customerType === 'existing' && selectedCustomer && (
                      <>
                        <div className="col-md-6">
                          <label htmlFor="customerName" className="form-label fw-bold">
                            Customer Name
                          </label>
                          <input
                            type="text"
                            id="customerName"
                            value={invoiceData.customerName}
                            className="form-control form-control-lg"
                            readOnly
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="customerAddress" className="form-label fw-bold">
                            Customer Address
                          </label>
                          <input
                            type="text"
                            id="customerAddress"
                            value={invoiceData.customerAddress}
                            className="form-control form-control-lg"
                            readOnly
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="customerPhone" className="form-label fw-bold">
                            Customer Phone
                          </label>
                          <input
                            type="text"
                            id="customerPhone"
                            value={invoiceData.customerPhone}
                            className="form-control form-control-lg"
                            readOnly
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="email" className="form-label fw-bold">
                            Customer Email
                          </label>
                          <input
                            type="email"
                            id="email"
                            value={invoiceData.email}
                            className="form-control form-control-lg"
                            readOnly
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="postcode" className="form-label fw-bold">
                            Postcode
                          </label>
                          <input
                            type="text"
                            id="postcode"
                            value={invoiceData.postcode}
                            className="form-control form-control-lg"
                            readOnly
                          />
                        </div>
                      </>
                    )}
                    {customerType === 'new' && (
                      <>
                        <div className="col-md-6">
                          <label htmlFor="customerName" className="form-label fw-bold">
                            Customer Name
                          </label>
                          <input
                            type="text"
                            id="customerName"
                            value={invoiceData.customerName}
                            onChange={(e) => handleInvoiceChange('customerName', e.target.value)}
                            className={`form-control form-control-lg ${errors.customerName ? 'is-invalid' : ''}`}
                          />
                          <div className="form-text">Enter the customer's full name.</div>
                          {errors.customerName && <div className="invalid-feedback">{errors.customerName}</div>}
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="customerAddress" className="form-label fw-bold">
                            Customer Address
                          </label>
                          <div style={{ position: 'relative' }}>
                            <input
                              type="text"
                              id="customerAddress"
                              value={invoiceData.customerAddress}
                              onChange={(e) => handleInvoiceChange('customerAddress', e.target.value)}
                              className={`form-control form-control-lg ${errors.customerAddress ? 'is-invalid' : ''}`}
                              ref={addressInputRef}
                            />
                            {errors.customerAddress && <div className="invalid-feedback">{errors.customerAddress}</div>}
                            {addressSuggestions.length > 0 && (
                              <ul
                                style={{
                                  position: 'absolute',
                                  zIndex: 1000,
                                  background: 'white',
                                  border: '1px solid #ccc',
                                  width: '100%',
                                  listStyle: 'none',
                                  padding: 0,
                                  maxHeight: '200px',
                                  overflowY: 'auto',
                                  borderRadius: '4px',
                                }}
                              >
                                {addressSuggestions.map((suggestion, index) => (
                                  <li
                                    key={index}
                                    style={{
                                      padding: '8px',
                                      cursor: 'pointer',
                                      borderBottom: '1px solid #eee',
                                      backgroundColor: '#fff',
                                    }}
                                    onClick={() => handleAddressSelect(suggestion)}
                                    onMouseEnter={(e) => (e.target.style.backgroundColor = '#f8f9fa')}
                                    onMouseLeave={(e) => (e.target.style.backgroundColor = '#fff')}
                                  >
                                    {suggestion.label}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                          <div className="form-text">Enter the customer's full address.</div>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="customerPhone" className="form-label fw-bold">
                            Customer Phone
                          </label>
                          <input
                            type="text"
                            id="customerPhone"
                            value={invoiceData.customerPhone}
                            onChange={(e) => handleInvoiceChange('customerPhone', e.target.value)}
                            className={`form-control form-control-lg ${errors.customerPhone ? 'is-invalid' : ''}`}
                          />
                          <div className="form-text">e.g., +44 123 456 7890</div>
                          {errors.customerPhone && <div className="invalid-feedback">{errors.customerPhone}</div>}
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="email" className="form-label fw-bold">
                            Customer Email
                          </label>
                          <input
                            type="email"
                            id="email"
                            value={invoiceData.email}
                            onChange={(e) => handleInvoiceChange('email', e.target.value)}
                            className={`form-control form-control-lg ${errors.email ? 'is-invalid' : ''}`}
                          />
                          <div className="form-text">e.g., customer@example.com</div>
                          {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="postcode" className="form-label fw-bold">
                            Postcode
                          </label>
                          <input
                            type="text"
                            id="postcode"
                            value={invoiceData.postcode}
                            onChange={(e) => handleInvoiceChange('postcode', e.target.value)}
                            className={`form-control form-control-lg ${errors.postcode ? 'is-invalid' : ''}`}
                          />
                          <div className="form-text">e.g., SW1A 1AA</div>
                          {errors.postcode && <div className="invalid-feedback">{errors.postcode}</div>}
                        </div>
                      </>
                    )}
                       <div className="col-md-12">
                      <label htmlFor="siteAddress" className="form-label fw-bold">
                        Site Address
                      </label>
                      <input
                        type="text"
                        id="siteAddress"
                        value={invoiceData.job_site_address}
                        onChange={(e) => handleInvoiceChange('job_site_address', e.target.value)}
                        className={`form-control form-control-lg `}
                      />
                      
                    </div>
                  </div>
                </div>
              )}

              {currentStep === 3 && (
                <div className="p-3 rounded bg-light">
                  <h2 className="h6 mb-4">Edit Items</h2>
                  <div className="card mb-4 shadow-sm">
                    <div className="card-body">
                      <div className="row g-3 align-items-end">
                        <div className="col-md-6">
                          <label htmlFor="itemType" className="form-label fw-bold">
                            Item Type
                          </label>
                          <select
                            id="itemType"
                            value={newItem.itemType}
                            onChange={(e) => {
                              setNewItem({ itemType: e.target.value, itemName: null, qty: '', unitPrice: '', description: '' });
                              if (quillInstance.current) {
                                quillInstance.current.root.innerHTML = '';
                                quillInstance.current.focus();
                              }
                              setErrors({});
                            }}
                            className="form-control form-control-lg"
                          >
                            <option value="stock">Stock</option>
                            <option value="service">Service</option>
                          </select>
                          <div className="form-text">Select item type.</div>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="itemName" className="form-label fw-bold">
                            {newItem.itemType === 'stock' ? 'Stock Item' : 'Service'}
                          </label>
                          <Select
                            inputId="itemName"
                            options={newItem.itemType === 'stock' ? stockList : optionsForServices}
                            value={newItem.itemName}
                            onChange={(e) => {
                              if (newItem.itemType === 'stock') {
                                onChangeStock(e);
                              } else {
                                onChangeService(e);
                              }
                            }}
                            className={`react-select ${errors.itemName ? 'is-invalid' : ''}`}
                            classNamePrefix="select"
                            placeholder={`Select ${newItem.itemType === 'stock' ? 'stock item' : 'service'}`}
                          />
                          <div className="form-text">
                            Select {newItem.itemType === 'stock' ? 'an item from stock' : 'a service'}.
                          </div>
                          {errors.itemName && <div className="invalid-feedback d-block">{errors.itemName}</div>}
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="unitPrice" className="form-label fw-bold">
                            Unit Price
                          </label>
                          <input
                            type="number"
                            id="unitPrice"
                            value={newItem.unitPrice}
                            onChange={(e) => handleItemChange('unitPrice', e.target.value)}
                            className={`form-control form-control-lg ${errors.unitPrice ? 'is-invalid' : ''}`}
                            placeholder="Unit Price"
                            readOnly={newItem.itemType === 'stock' && newItem.itemName}
                          />
                          <div className="form-text">Enter the unit price.</div>
                          {errors.unitPrice && <div className="invalid-feedback">{errors.unitPrice}</div>}
                        </div>
                        {newItem.itemType === 'stock' && (
                          <div className="col-md-6">
                            <label htmlFor="qty" className="form-label fw-bold">
                              Quantity
                            </label>
                            <input
                              type="number"
                              id="qty"
                              value={newItem.qty}
                              onChange={(e) => handleItemChange('qty', e.target.value)}
                              className={`form-control form-control-lg ${errors.qty ? 'is-invalid' : ''}`}
                              placeholder="Quantity"
                            />
                            <div className="form-text">Enter the quantity.</div>
                            {errors.qty && <div className="invalid-feedback">{errors.qty}</div>}
                          </div>
                        )}
                        <div className="col-md-12">
                          <label htmlFor="description" className="form-label fw-bold">
                            Description
                          </label>
                          <div
                            ref={quillRef}
                            className={`ql-container ${errors.description ? 'is-invalid' : ''}`}
                          />
                          <div className="form-text">Provide a detailed description of the item or service (supports bold, bullet points, etc.).</div>
                          {errors.description && <div style={{ color: '#dc3545', fontSize: '0.875em' }}>{errors.description}</div>}
                        </div>
                        <div className={newItem.itemType === 'stock' ? 'col-md-4' : 'col-md-4'}>
                          <label className="form-label fw-bold d-block"> </label>
                          <button onClick={addItem} className="btn btn-success btn-lg w-100">
                            <Icon icon="simple-line-icons:plus" className="me-2" />
                            Add Item
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {errors.items && <div className="alert alert-danger mb-4">{errors.items}</div>}
                  {invoiceItems.length > 0 && (
                    <div className="table-responsive mb-4">
                      <table className="table table-bordered table-hover">
                        <thead className="table-light">
                          <tr>
                            <th scope="col">SL.</th>
                            <th scope="col">Item</th>
                            <th scope="col">Quantity</th>
                            <th scope="col">Unit Price</th>
                            <th scope="col">Price</th>
                            <th scope="col" className="text-center">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {invoiceItems.map((item, index) => (
                            <tr key={item.id}>
                              <td>{index + 1}</td>
                              <td>
                                <p>{item.itemName?.label || item.itemName?.value}</p>
                                <style>
      {`td ol, td ul{
          padding-left:30px;
          list-style:auto;
      }`}
  </style>
                                <div dangerouslySetInnerHTML={{ __html: item.description || 'N/A' }} />
                              </td>
                              <td>{item.qty}</td>
                              <td>£{item.unitPrice.toFixed(2)}</td>
                              <td>£{item.price}</td>
                              <td className="text-center">
                                <button onClick={() => removeItem(item.id)} className="btn btn-danger btn-sm">
                                  <Icon icon="ic:twotone-close" />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label htmlFor="discount" className="form-label fw-bold">
                        Discount (%)
                      </label>
                      <input
                        type="number"
                        id="discount"
                        value={discount}
                        onChange={(e) => setDiscount(Number(e.target.value))}
                        className="form-control form-control-lg"
                        placeholder="Enter discount"
                      />
                      <div className="form-text">Enter discount percentage.</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="tax" className="form-label fw-bold">
                        VAT (%)
                      </label>
                      <input
                        type="number"
                        id="tax"
                        value={taxAmount}
                        onChange={(e) => setTaxAmount(Number(e.target.value))}
                        className="form-control form-control-lg"
                        placeholder="Enter tax"
                      />
                      <div className="form-text">Enter VAT percentage.</div>
                    </div>
                    <div className="col-12 text-end">
                      <p className="mb-1">
                        <strong>Total Net Amount:</strong> £{calculateSubtotal().toFixed(2)}
                      </p>
                      <p className="mb-1">
                        <strong>Discount:</strong> £{calculateDiscount().toFixed(2)}
                      </p>
                      <p className="mb-1">
                        <strong>VAT Amount:</strong> £{calculateTax().toFixed(2)}
                      </p>
                      <p className="mb-0">
                        <strong>Invoice Total:</strong> £{calculateTotal().toFixed(2)}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {currentStep === 4 && (
                <div className="p-3 rounded">
                  <h2 className="h6 mb-4">Invoice Preview</h2>
                  <div className="border rounded p-4 bg-white" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                    <div dangerouslySetInnerHTML={{ __html: renderTemplate() }} />
                  </div>
                </div>
              )}

              <div className="d-flex justify-content-between mt-5">
                {currentStep > 1 && (
                  <button onClick={handleBack} className="btn btn-secondary btn-lg">
                    Back
                  </button>
                )}
                <div>
                  {currentStep < 4 && (
                    <button onClick={handleNext} className="btn btn-primary btn-lg">
                      Next
                    </button>
                  )}
                  {currentStep === 4 && (
                    <button
                      onClick={handleInvoiceSubmit}
                      className="btn btn-success btn-lg"
                      disabled={isSubmitting}
                    >
                      <Icon icon="simple-line-icons:check" className="me-2" />
                      {isSubmitting ? 'Updating...' : 'Update Invoice'}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceEditLayer;